export default "__VITE_ASSET__BiZLYie5__"